import { Link } from "react-router-dom";

const FeedbackSection = () => {
    return (
        <section className="bg-white pt-0 pb-20 px-8 relative">
            <div className="max-w-[1440px] mx-auto px-6 mb-12">
                <hr className="border-slate-100" />
            </div>
            <div className="max-w-4xl mx-auto text-center">
                {/* Icon */}
                <div className="flex justify-center mb-6">
                    <div className="h-16 w-16 bg-sky-600 rounded-full flex items-center justify-center text-white shadow-lg shadow-sky-200">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                        </svg>
                    </div>
                </div>

                {/* Text Content */}
                <h2 className="text-3xl md:text-5xl font-black text-gray-900 tracking-tight mb-4">
                    We're still fine-tuning.
                </h2>
                <p className="text-gray-500 text-sm md:text-lg font-medium max-w-2xl mx-auto mb-8 leading-relaxed">
                    Two minutes of feedback today means a smoother experience for everyone tomorrow.
                </p>

                {/* Button */}
                <div className="flex justify-center">
                    <Link
                        to="/feedback"
                        className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-white backdrop-blur-md font-bold isolation-auto border-gray-50 before:absolute before:inset-y-0 before:my-auto before:-left-full before:w-full before:aspect-square before:rounded-full before:bg-sky-500 hover:text-white before:-z-10 before:transition-all before:duration-700 hover:before:left-0 hover:before:scale-150 relative z-10 px-8 py-3 overflow-hidden border-2 rounded-full group transition-transform active:scale-95"
                    >
                        Give Feedback
                        <svg
                            className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-white text-gray-50 ease-linear duration-300 rounded-full border border-gray-700 group-hover:border-none p-2 rotate-45 transition-all"
                            viewBox="0 0 16 19"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                className="fill-gray-800"
                            ></path>
                        </svg>
                    </Link>
                </div>
            </div>

            {/* Bottom Accent Line */}
            <div className="absolute bottom-0 left-0 right-0 h-2 bg-sky-900"></div>
        </section>
    );
};

export default FeedbackSection;
